import React from 'react';
import styles from 'assets/jss/material-dashboard-pro-react/layouts/adminStyle';
import { Hidden, makeStyles } from '@material-ui/core';
import apiConfig from 'utils/api/config';

import { Box, Grid, Typography, Link } from '@material-ui/core';
import Icon from './Icon';
import { getFooterLabels } from 'redux/modules/dynamicLabels/selectors';
import { useSelector } from 'react-redux';
import PageContainer from './PageContainer/PageContainer';
import logo from 'assets/img/icons/oman-new-logo.svg';
import { setDataLayer } from 'commons/gtm/dataLayerWrapper';
import { getLanguage } from 'utils/language/language';
import { upIdSelector } from 'redux/modules/session/selectors';

const { faceBookLink, instagramLink, twitterLink, youtubeLink, whatsappLink } = apiConfig.links;
const SUPPORT_PHONE = apiConfig.SUPPORT_PHONE;

// @ts-ignore
const useStyles = makeStyles(styles);

const Footer = () => {
	const classes = useStyles();
	const footerLabels = useSelector(getFooterLabels);
	const accId = useSelector(upIdSelector);
	const links = [
		{ href: apiConfig.links.businessLink, label: footerLabels?.omantelWebsite },
		{ href: apiConfig.links.privacyPolicy, label: footerLabels?.privacyPolicy },
		{ href: apiConfig.links.copyrights, label: footerLabels?.copyrights },
		{ href: apiConfig.links.standardCustomerAgreement, label: footerLabels?.sca },
	];

	return (
		<footer className={classes.footerBox}>
			<PageContainer>
				<Grid container>
					<Grid item container className={classes.reverseMenuContact} xs={12} sm={8}>
						<Grid item xs={12} sm={6} className={classes.footerGrid}>
							<Typography variant="caption" component="p" className={classes.footerLinkHead}>
								{footerLabels?.quickContact}
							</Typography>
							<Link
								href={`tel:${SUPPORT_PHONE}`}
								className={classes.footerEBULink}
								color="inherit"
								display="block"
								data-linktype={`footer_${footerLabels.businessCallCentre}`}
							>
								<Icon name="CallCalling" />
								<Typography
									variant="body1"
									component="span"
									display="inline"
									className={classes.supportPhone}
								>
									{SUPPORT_PHONE}
								</Typography>
								<Typography variant="body1" component="span" className={classes.businessCentre}>
									{footerLabels?.businessCallCentre}
								</Typography>
							</Link>
						</Grid>
						<Grid item xs={12} sm={6} className={classes.footerGrid}>
							<Hidden xsDown>
								<Typography variant="caption" component="p" className={classes.footerLinkHead}>
									{footerLabels?.mainMenu}
								</Typography>
							</Hidden>
							{links.map((link, index) => (
								<Link
									key={index}
									href={link.href}
									target="_blank"
									rel="noopener noreferrer"
									color="inherit"
									display="block"
									variant="body2"
									className={classes.footerEBULink}
									data-linktype={`footer_${link.label}`}
								>
									{link.label}
								</Link>
							))}
						</Grid>
					</Grid>

					<Grid item xs={12} sm={4} className={classes.footerGrid}>
						<Typography variant="caption" component="p" className={classes.footerLinkHead}>
							{footerLabels?.socialMediaFollow}
						</Typography>
						<Box mb={2}>
							<Link
								href={faceBookLink}
								className={classes.socialLink}
								target="_blank"
								aria-label={footerLabels.facebookPage}
								data-linktype={`footer_${footerLabels.facebookPage}`}
							>
								<Icon name="Facebook" />
							</Link>
							<Link
								href={instagramLink}
								className={classes.socialLink}
								target="_blank"
								aria-label={footerLabels.instagramPage}
								data-linktype={`footer_${footerLabels.instagramPage}`}
							>
								<Icon name="Instagram" />
							</Link>
							<Link
								href={twitterLink}
								target="_blank"
								className={classes.socialLink}
								aria-label={footerLabels.twitterPage}
								data-linktype={`footer_${footerLabels.twitterPage}`}
							>
								<Icon name="Twitter" />
							</Link>
							<Link
								href={youtubeLink}
								className={classes.socialLink}
								target="_blank"
								aria-label={footerLabels.youtubePage}
								data-linktype={`footer_${footerLabels.youtubePage}`}
							>
								<Icon name="Youtube" />
							</Link>
							<Link
								href={whatsappLink}
								className={classes.socialLink}
								target="_blank"
								aria-label={footerLabels.whatsappPage}
								data-linktype={`footer_${footerLabels.whatsappPage}`}
							>
								<Icon name="Whatsapp" />
							</Link>
						</Box>
					</Grid>
				</Grid>
				<Box>
					<Link
						href={apiConfig.links.businessLink}
						target="_blank"
						className={classes.footerOmanLogo}
						data-linktype={`footer_${footerLabels.oman_logo}`}
					>
						<img src={logo} width="97px" alt={footerLabels.oman_logo} />
					</Link>
					<Typography variant="body2" className={classes.footerOTC}>
						{footerLabels?.otc}
					</Typography>
				</Box>
			</PageContainer>
		</footer>
	);
};
export default Footer;
